import { Avatar } from '@octopus-do/octopus-storybook'
import type React from 'react'

import type { Team as TeamModel } from '@/types/models'
import css from './styles.module.css'

type Props = {
  team: TeamModel
  // A report in a workspace is editable by its active members, the way any
  // project there is. The row says so; there is nothing to choose.
  canEdit?: boolean
}

export const Team: React.FC<Props> = ({ team, canEdit = false }) => (
  <div className={css.container}>
    <div className={css.team}>
      <div className={css.avatar_wrap}>
        {team.avatar && (
          <Avatar media={team.avatar} color="" name={team.name} />
        )}

        {!team.avatar && <Avatar name={team.name} color="collab-10" />}
      </div>

      <div className={css.name}>{team.name}</div>

      {canEdit && <div className={css.permission}>Can edit</div>}
    </div>
  </div>
)
